import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import styles from './jocPeu.module.scss';

const JocPeu = (props) => {
    const { titolRequisits, textRequisits, imatgeSrc, href, textLogo, altLogo } = props;

    const renderTextRequisits = () => {
        if (Array.isArray(textRequisits)) {
            return (
                <ul>
                    {textRequisits.map((requisit, index) => (
                        <li key={index}>{requisit}</li>
                    ))}
                </ul>
            );
        } else {
            // Mantenir compatibilitat amb strings que contenen <br>
            return <div dangerouslySetInnerHTML={{ __html: textRequisits }} />;
        }
    };

    return (
        <div className={styles.peu}>
            {titolRequisits && (
                <div className={styles.contentPeu}>
                    <h4>{titolRequisits}</h4>
                    {renderTextRequisits()}
                </div>
            )}
            <div className={styles.contentPremis}>
                <div className={styles.contentImatge}>
                    <Enllac href={href}>
                        <Imatge src={imatgeSrc} layout='fill' objectFit='cover' alt={altLogo} />
                    </Enllac>
                </div>
                <p className={styles.textPremis}>{textLogo}</p>
            </div>
        </div>
    );
};

export default JocPeu;
